//@flow
import React, {useState} from 'react';
import {ButtonBase, makeStyles} from '@material-ui/core';
import type {Theme} from '@material-ui/core';

import type {MessageMultimedia} from '../../../../../../../../entities';
import AudioPlayer from '../../../../../../../../elements/AudioPlayer';
import TiendadaTooltip from '../../../../../../../../elements/tiendada-tooltip';
import {ReportProblem} from '@material-ui/icons';
import {useCurrentConversation} from '../../../../../utils/conversation';
import {fetchWhatsappApiMedia} from '../../../../../utils/message';
import InlineLoader from '../../../../../../../../elements/LoadingSpinner/InlineLoader';

const useStyles = (props: any) =>
  makeStyles((theme: Theme) => ({
    container: {
      position: 'relative',
      display: 'flex',
      gap: '.25rem',
      alignItems: 'center',
      width: '100%',
      maxWidth: '300px',
      minWidth: '250px',

      '&[data-self="true"]': {
        flexDirection: 'row-reverse',
      },
    },
    audioPlayer: {
      background: props.self ? '#d5bfff' : '#F4F4F6',
      borderRadius: '.75rem',
    },
    loading: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      background: 'rgba(255, 255, 255, 0.8)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1,
    },
    errorIcon: {
      padding: '.25rem',
      borderRadius: '50%',
    },
  }));

type Props = {
  audio: MessageMultimedia,
  self: boolean,
  isUnreachable?: boolean,
};

const TOOLTIP_MESSAGE =
  'El archivo no se encuentra disponible. Ingresa a la aplicación (Instagram o Facebook) para poder visualizarlo.';

export default function AudioMessage({audio, self, isUnreachable}: Props) {
  const classes = useStyles({self})();

  const {currentConversation} = useCurrentConversation();

  const [src, setSrc] = useState(audio.src);
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const handleClick = () => {
    if (!currentConversation) return;

    if (audio.mediaId) {
      setLoading(true);
      fetchWhatsappApiMedia(currentConversation.deviceId, audio?.mediaId || '')
        .then(source => {
          setSrc(source);
        })
        .catch(() => {
          console.log('Error fetching audio media');
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const showErrorIcon = isUnreachable || hasError;

  if (!src) {
    return (
      <div className={classes.container} data-self={self} onClick={handleClick}>
        <AudioPlayer
          disabled
          src=""
          classes={{
            root: classes.audioPlayer,
          }}
        />
        {loading && (
          <div className={classes.loader}>
            <InlineLoader loading size={20} />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={classes.container} data-self={self}>
      <AudioPlayer
        src={src}
        classes={{
          root: classes.audioPlayer,
        }}
        onError={() => setHasError(true)}
      />

      {showErrorIcon && (
        <TiendadaTooltip
          title={TOOLTIP_MESSAGE}
          arrow
          placement={self ? 'left' : 'right'}
        >
          <ButtonBase className={classes.errorIcon}>
            <ReportProblem color="error" fontSize="small" />
          </ButtonBase>
        </TiendadaTooltip>
      )}
    </div>
  );
}
